import { RiskScoreLevelEnum } from '@/api';

export default function getRiskTypeByLevel(level: RiskScoreLevelEnum): string {
  switch (level) {
    case RiskScoreLevelEnum.LOW:
      return 'trusted';
    case RiskScoreLevelEnum.MEDIUM:
      return 'suspicious';
    case RiskScoreLevelEnum.HIGH:
      return 'danger';
    default:
      return 'unknown';
  }
}
